import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "m_mb16" }
const _hoisted_2 = {
  key: 0,
  class: "separation"
}
const _hoisted_3 = { class: "m_flex m_gap10 m_flex-wrap m_justify-center m_align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseText = _resolveComponent("BaseText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createBlock(_component_BaseDialog, {
    modelValue: _ctx.isVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVisible) = $event)),
    "content-width": "1043px",
    close: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_BaseCard, { class: "m_bg-accent-gradient m_pb51 m_pt42 m_px16 m_flex m_flex-column m_border-none m_align-center" }, {
        default: _withCtx(() => [
          (_ctx.title)
            ? (_openBlock(), _createBlock(_component_BaseText, {
                key: 0,
                tag: "div",
                class: _normalizeClass(["m_my-auto m_sh6 m_bold m_mw740 m_text-center mm_sh1", {'m_mb16': _ctx.message.length}]),
                innerHTML: _ctx.title
              }, null, 8, ["class", "innerHTML"]))
            : _createCommentVNode("", true),
          (_ctx.message.length)
            ? (_openBlock(), _createBlock(_component_BaseText, {
                key: 1,
                tag: "div",
                class: "m_my-auto m_h1 m_mw740 m_text-center m_mb50 mm_h4 mm_mb16"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message, (m, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: 'message' + i
                      }, [
                        _createTextVNode(_toDisplayString(m) + " ", 1),
                        (!m)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2, " "))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.activeButton && _ctx.activeButtonCallback)
              ? (_openBlock(), _createBlock(_component_BaseButton, {
                  key: 0,
                  class: "m_h46 m_w215 m_font-big m_border-none plc_email-request-submit-input",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.activeButtonCallback?.();_ctx.isVisible=false})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.activeButton), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_BaseButton, {
              class: "m_h46 m_w215 m_font-big m_border-none plc_email-request-submit-input",
              variant: "accent",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisible=false))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode(" Закрыть ")
              ])),
              _: 1,
              __: [3]
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}